/* eslint-disable */
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  RegisterOptions,
  UseFormRegisterReturn,
} from 'react-hook-form';

import { Colors, FontWeights, TextAligns, TextTransforms } from 'themes/config';

export type ColorName = keyof Colors;
export type FontWeightName = keyof FontWeights;
export type TextTransformName = keyof TextTransforms;
export type TextAlignName = keyof TextAligns;

export type LayoutName = 'layout' | 'grid' | 'grid2';

export type FontFamily = 'LFT Zeno' | 'LFT Zeno Condensed';

export type CellType = {
  id: number;
  value: string | number | React.ReactNode;
  colSpan?: number;
};

export type AttributesData = {
  name: string;
  family_name: string;
};

export type RowType = {
  id: number;
  data: CellType[];
};

export type Row = {
  index: number;
  cells: any;
  getRowProps: () => any;
  original: any;
};

export type TablesType = {
  title: string;
  data: RowType[];
};

export type EditField = {
  name: string;
  label: string;
};

export type SubCategory = {
  id: number;
  name_en: string;
  name_it: string;
};

export type Constant = {
  key: string;
  value: string;
};

export type RegisterType = (name: string, options?: RegisterOptions) => UseFormRegisterReturn;

export type Option = {
  value: string | number | null;
  label: string | number;
  // motive?: SelectMotives;
  additional?: {
    [x: string]: string;
  };
};

export type Filter = {
  label: string;
  name: string;
  placeholder?: string;
  type?: 'input' | 'select' | 'checkbox' | 'date';
  options?: Option[];
  disabled?: boolean;
  flexBasis?: string;
  flex?: number;
};

export type FilterGroup = {
  id: number;
  filters: Filter[];
  isCentered?: boolean;
};

export type Object = { [key: string]: string };

export type Constants = {
  CustomerStructure: Constant[];
  ShopWholesaleFurniture: Constant[];
  ShopArea: Constant[];
  ShopLayout: Constant[];
  ShopLocation: Constant[];
  ShopMaxPrice: Constant[];
  ShopRanking: Constant[];
  ShopSeasons: Constant[];
  ShopStructureBrandLine: Constant[];
  ShopStructureBrandName: Constant[];
  ShopStructureColmarLine: Constant[];
  ShopStructureLacosteLine: Constant[];
  ShopStructureCategory: Constant[];
  ShopStructureGender: Constant[];
  ShopSurface: Constant[];
  ShopWindows: Constant[];
  ShopModel: Constant[];
  ShopType: Constant[];
  ShopTypeDescription: Constant[];
};

export type Name = {
  id: string;
  name: string;
};

export type Structure = {
  key: string;
  value: string;
};

export type StatusType =
  | 'IN_PROGRESS'
  | 'IN_REVIEW'
  | 'ACCEPTED'
  | 'REFUSED'
  | 'ABANDONED'
  | 'NEW'
  | 'DELETED'
  | 'DELETE_REQUESTED';

export type Season = {
  season: string;
  descEng: string;
  descIt: string;
  timestamp: string;
  actions?: string[];
};

export type SeasonCatalog = {
  season: string;
  catalog: string[];
};

export enum Permissions {
  ADMIN = 'ADMIN',
  CATALOGUE = 'CATALOGUE',
  CUSTOMER_MAPPER = 'CUSTOMER_MAPPER',
  NOTIFICATIONS = 'NOTIFICATIONS',
  VIEW_PRICE = 'VIEW_PRICE',
  VIEW_INACTIVE_ITEMS = 'VIEW_INACTIVE_ITEMS',
  INSERT_ORDER = 'INSERT_ORDER',
  INSERT_BUDGET = 'INSERT_BUDGET',
  VIEW_ORDER = 'VIEW_ORDER',
  DISTRIBUTOR = 'DISTRIBUTOR',
  VIEW_DISTRIBUTOR_PRICE = 'VIEW_DISTRIBUTOR_PRICE',
  USERS = 'USERS',
}

export type InitialSorting = {
  id: string;
  desc: boolean;
};

export type PostalCode = {
  adminCode1: string;
  adminName1: string;
  adminName2: string;
  adminName3: string;
  countryCode: string;
  placeName: string;
  latinAdminName1: string;
  latinAdminName2: string;
  latinAdminName3: string;
  toponymName: string;
  postalCode: string;
};

export type PostData = {
  [x: string]: any; // eslint-disable-line
};

export type CustomerCheckbox = {
  label: string;
  value: string;
  name: string;
  data?: CustomerCheckbox[];
  checked?: boolean;
  disabled?: boolean;
};

export type CustomerCheckboxGroup = {
  title: string;
  name: string;
  data: CustomerCheckbox[];
  required?: boolean;
  visible: boolean;
};

export type Zone = {
  code: string;
  desc: string;
  location: string;
  type: {
    key: string;
    value: string;
  };
};

export type ErrorType =
  | string
  | FieldError
  | Merge<FieldError, FieldErrorsImpl<any>>
  | undefined; // eslint-disable-line

export type RowColor = {
  background: ColorName;
  color: ColorName;
};

export type CustomerAsset = 'customer' | 'warehouse' | 'shop';
